import { forwardRef, type InputHTMLAttributes, useId } from 'react'
import { type IMask, IMaskInput } from 'react-imask'
import { cn } from '#src/cn.ts'

export interface MaskedInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange'
> {
  mask: string
  unmask?: boolean | 'typed'
  onAccept?: (
    value: string,
    maskRef: InstanceType<typeof IMask.InputMask>,
    event?: InputEvent
  ) => void
  overwrite?: boolean | 'shift'
}

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ className, id: idProp, ...props }, ref) => {
    const generatedId = useId()
    const id = idProp ?? generatedId

    return (
      /* @ts-expect-error react-imask types are incompatible with React 19 */
      <IMaskInput
        id={id}
        inputRef={ref}
        className={cn(
          'flex h-10 w-full rounded-md border border-zinc-200 bg-transparent px-3 py-2 text-sm ring-offset-white placeholder:text-zinc-500 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-zinc-800 dark:ring-offset-zinc-950 dark:focus-visible:ring-zinc-300 dark:placeholder:text-zinc-400',
          className
        )}
        {...props}
      />
    )
  }
)

MaskedInput.displayName = 'MaskedInput'
